'use client';

import { createContext, type ReactNode, useCallback, useContext, useState } from 'react';

interface BalanceContextValue {
  balance: number;
  setBalance: (balance: number) => void;
  isInitialized: boolean;
}

const BalanceContext = createContext<BalanceContextValue | undefined>(undefined);

export function BalanceProvider({ children }: { children: ReactNode }) {
  const [balance, setBalanceState] = useState<number>(0);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  const handleSetBalance = useCallback((newBalance: number) => {
    setBalanceState(newBalance);
    setIsInitialized(true);
  }, []);

  return (
    <BalanceContext.Provider value={{ balance, setBalance: handleSetBalance, isInitialized }}>
      {children}
    </BalanceContext.Provider>
  );
}

export function useBalance() {
  const context = useContext(BalanceContext);
  if (!context) {
    throw new Error('useBalance must be used within BalanceProvider');
  }
  return context;
}
